"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Button = _interopRequireDefault(require("../../../Button")),
    _navModal = require("../../styles/navModal");

function ModalFooter(a) {
  var b = a.primaryAction,
      c = a.secondaryAction,
      d = a.primaryText,
      e = a.secondaryText;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_navModal.FOOTER, "modal__footer")
  }, _react["default"].createElement(_Button["default"], {
    className: "first-button",
    small: !0,
    type: "PRIMARY",
    onClick: b
  }, d), c && e ? _react["default"].createElement(_Button["default"], {
    small: !0,
    type: "TERTIARY",
    onClick: c
  }, e) : null);
}

var _default = (0, _react.memo)(ModalFooter);

exports["default"] = _default;